import React, { useContext } from 'react';
import SearchContext from '../data/FunnelbackContext';
import styles from '../../css/functional.module.scss';

function SortByFilter() {
    const { defaultSortByFilterOptions, sortByFilter, setSortByFilter, advancedSortByFilterOptions } = useContext(SearchContext);

    return (
        <div className={`${styles.sortByFilter} funnelback-instant-search-sort-by-filter`}>
            <select
                value={sortByFilter}
                name="sort by filter"
                onChange={(e) => {
                    // As relevance requires an empty string to work with FB.
                    if (e.target.value === 'relevance') {
                        setSortByFilter('');
                    } else {
                        setSortByFilter(e.target.value);
                    }
                }}
            >
                {(advancedSortByFilterOptions.length ? advancedSortByFilterOptions : defaultSortByFilterOptions).map(
                    ([value, title], i) => {
                        const key = `sort-by-filter-${i}`;
                        return (
                            <option key={key} value={value} name={title}>
                                {title}
                            </option>
                        );
                    }
                )}
            </select>
            <svg aria-hidden="true">
                <title>Down Arrow</title>
                <use href="#chevron-down" />
            </svg>
        </div>
    );
}

export default SortByFilter;
